import React from "react"

export const Loader = ({ loading = true, text = "Loading..." }) => (
  <div className={`layout-loading ${loading ? "loading" : ""}`}>
    <div className="redirect-content">{text}</div>
    <div className="animation-dots" />
  </div>
)
